<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-text-field
          v-model="suche"
          append-icon="mdi-table-search"
          label="Suche"
          single-line
          hide-details
        />
      </v-col>
      <v-col>
        <v-switch
          v-model="showPrices"
          :label="`Zeige Umsätze`"
          :value="false"
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="offerList"
      :search="suche"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [-1, 50, 100],
      }"
      @click:row="navigateToOffer"
    >
      <template #[`item.turnover`]="{ item }">
        {{ item.turnover ? moneyFormatter.format(item.turnover) : "-" }}
      </template>
      <template #[`item.turnover_one_time`]="{ item }">
        {{
          item.turnover_one_time
            ? moneyFormatter.format(item.turnover_one_time)
            : "-"
        }}
      </template>
      <template #[`item.monthly_turnover`]="{ item }">
        {{
          item.monthly_turnover
            ? moneyFormatter.format(item.monthly_turnover)
            : "-"
        }}
      </template>
      <template #[`item.company_name`]="{ item }">
        <inertia-link
          :href="
            route('customer.show.uebersicht', { customer: item.company_id })
          "
        >
          <span>{{ item.company_name }}</span>
        </inertia-link>
      </template>
      <template #[`item.created_at`]="{ item }">
        <span>{{ getDateString(item.created_at) }}</span>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-menu v-if="actionMenu" offset-y>
          <template #activator="{ on }">
            <v-btn v-on="on">
              aktionen
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click.stop="replicateOfferData(item.offer_data_id)">
              <v-list-item-icon>
                <v-icon> mdi-content-copy </v-icon>
              </v-list-item-icon>
              <v-list-item-title> Kopieren </v-list-item-title>
            </v-list-item>

            <v-list-item @ @click.stop="setStatusItem(item)">
              <v-list-item-icon>
                <v-icon> mdi-publish </v-icon>
              </v-list-item-icon>
              <v-list-item-title> Status ändern </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div v-else>
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon
                class="mr-3"
                v-bind="attrs"
                v-on="on"
                @click.stop="replicateOfferData(item.offer_data_id)"
              >
                mdi-content-copy
              </v-icon>
            </template>
            <span>kopieren</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon
                class="mr-3"
                v-bind="attrs"
                @click.stop="setStatusItem(item)"
                v-on="on"
              >
                mdi-publish
              </v-icon>
            </template>
            <span>Status ändern</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <statuswahl
      :offer="statuswahlOffer"
      :offerstatus="offerstati"
      :opened="dialog"
      @close="dialog = false"
    />
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import axios from 'axios'
import { formattedDateTimeString } from '@/plugins/formatDate.js'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Angebotsübersicht',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      offerList: {
         type: Array,
         required: true,
      },
      offerstati: {
         type: Array,
         required: true,
      },
   },
   remember: {
      data: ['showPrices', 'options', 'suche'],
      key: 'History/Index',
   },
   data () {
      return {
         loading: false,
         tableItems: [],
         totalItems: 0,
         options: {
            page: 1,
            itemsPerPage: 50,
            sortBy: ['created_at'],
            sortDesc: [true],
            multiSort: false,
         },
         dialog: false,
         statuswahlOffer: null,
         suche: '',
         tableFilters: {
            angebot_type: [],
         },
         showPrices: true,
         moneyFormatter: new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
         }),
      }
   },
   computed: {
      headers () {
         if (this.showPrices) {
            return [
               {
                  text: 'Nr.',
                  align: 'start',
                  sortable: true,
                  filterable: true,
                  value: 'id',
               },
               {
                  text: 'Status',
                  value: 'status',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Kunde',
                  value: 'company_name',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Angebotstyp',
                  value: 'angebot_type',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'VB',
                  value: 'performer_full_name',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Umsatz',
                  value: 'turnover',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Umsatz einmalig',
                  value: 'turnover_one_time',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Umsatz/Monat',
                  value: 'monthly_turnover',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Laufzeit in M',
                  value: 'months',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Datum',
                  value: 'created_at',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Aktionen',
                  value: 'actions',
                  sortable: false,
                  filterable: false,
                  width: '20%',
               },
            ]
         } else {
            return [
               {
                  text: 'Nr.',
                  align: 'start',
                  filterable: true,
                  sortable: true,
                  value: 'id',
               },
               {
                  text: 'Status',
                  value: 'status',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Kunde',
                  value: 'company_name',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Angebotstyp',
                  value: 'angebot_type',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'VB',
                  value: 'performer_full_name',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Datum',
                  value: 'created_at',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Aktionen',
                  value: 'actions',
                  sortable: false,
                  filterable: false,
                  width: '20%',
               },
            ]
         }
      },
   },
   methods: {
      columnValueList (val) {
         const list = this.offerList
            .map((offer) => offer[val])
            .filter(
               (value, index, self) => self.indexOf(value) === index && value !== ''
            )
         return list
      },
      setStatusItem (item) {
         this.statuswahlOffer = item
         this.dialog = true
      },
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      async duplicateItem (item) {
         await axios
            .post(`/api/offerData/${item.id}/replicate`, {
               _token: this.$page.props.csrf_token,
            })
            .then(function (response) {
               console.log(response)
               // this.editItem(response.data.id);
            })
            .catch((error) => {
               console.log(error.response)
            })
      },
      navigateToOffer (_offer, second) {
         this.$inertia.visit(this.route('offer.show', _offer))
      },
      replicateOfferData (_offer) {
         this.$inertia.post(this.route('offerData.replicate', _offer))
      },
   },
}
</script>
